import { Pagination } from '@alfresco/js-api';
import { ProcessInstanceTasksEntry } from './process-instance-tasks-entry';

/**
 * REST API model
 */
export class ProcessInstanceTasksPagingList {
  pagination: Pagination;
  entries: ProcessInstanceTasksEntry[];

  constructor(input?: any) {
    if (input) {
      Object.assign(this, input);
      this.pagination = input.pagination ? new Pagination(input.pagination) : undefined;
      if (input.entries) {
        this.entries = input.entries.map((item: any) => {
          return new ProcessInstanceTasksEntry(item);
        });
      }
    }
  }
}
